import React, { useCallback, useEffect, useState } from "react";
import {
  Typography,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TextField,
  Button,
  Box,
} from "@mui/material";
import SEO from "../../components/SEO";
import apiClient from "../../services/apiClient";

export default function AdminAuditLogsPage() {
  const [action, setAction] = useState("");
  const [data, setData] = useState({ rows: [], total: 0 });

  const load = useCallback(() => {
    const params = new URLSearchParams();
    if (action) params.set("action", action);
    apiClient.request(`/api/admin/audit-logs?${params.toString()}`).then(setData);
  }, [action]);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <>
      <SEO title="Admin Audit Logs | DigiBuddy" noIndex noFollow />
      <Typography variant="h4" sx={{ mb: 2 }}>
        Audit logs
      </Typography>
      <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
        <TextField
          size="small"
          label="Filtrer action"
          value={action}
          onChange={(e) => setAction(e.target.value)}
        />
        <Button variant="contained" onClick={load}>
          Filtrer
        </Button>
      </Box>
      <Paper sx={{ overflow: "auto" }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Date</TableCell>
              <TableCell>Actor</TableCell>
              <TableCell>Action</TableCell>
              <TableCell>Cible</TableCell>
              <TableCell>Payload</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.rows?.map((row) => (
              <TableRow key={row.id}>
                <TableCell>{new Date(row.created_at).toLocaleString()}</TableCell>
                <TableCell>{`${row.actor_type}${row.actor_id ? ` (${row.actor_id})` : ""}`}</TableCell>
                <TableCell>{row.action}</TableCell>
                <TableCell>{`${row.target_type}${row.target_id ? ` (${row.target_id})` : ""}`}</TableCell>
                <TableCell>
                  <pre style={{ margin: 0, whiteSpace: "pre-wrap" }}>
                    {row.payload ? JSON.stringify(row.payload, null, 2) : "-"}
                  </pre>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    </>
  );
}
